// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"065d80be","101":"77049be0","106":"8ca04aa5","259":"0db304ac","337":"9c876bc7","518":"c14f8141","559":"d21de6da","590":"09efd430","657":"9caaefb2","764":"40a7ed3f","787":"c19f9618","823":"3b64a6ff","975":"276efb87"}[chunkId] + ".chunk.js";
};